import { motion } from "framer-motion";

/* ---------- scroll reveal wrapper ---------- */
export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

/* ---------- section eyebrow tag ---------- */
export const SectionTag = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 font-bebas text-sm sm:text-base tracking-[0.25em] uppercase ${className}`}
    data-testid="section-tag"
  >
    <StarDoodle className="w-4 h-4" />
    {children}
  </span>
);

/* ---------- polaroid frame ---------- */
export const Polaroid = ({ src, alt, caption, rotate = "-rotate-2", className = "", children, eager = false }) => (
  <div className={`polaroid ${rotate} ${className}`}>
    <div className="relative overflow-hidden">
      <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} className="w-full h-full object-cover block" />
      {children}
    </div>
    {caption ? (
      <p className="font-hand text-xl sm:text-2xl text-ink/80 text-center leading-none pt-2 pb-1">{caption}</p>
    ) : null}
  </div>
);

export const Tape = ({ className = "" }) => <div aria-hidden="true" className={`tape ${className}`} />;

/* ---------- doodles ---------- */
export const StarDoodle = ({ className = "", style }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} style={style} aria-hidden="true">
    <path
      d="M12 2c.6 4.8 1.2 7.4 2.9 9.1C16.6 12.8 19.2 13.4 24 14c-4.8.6-7.4 1.2-9.1 2.9C13.2 18.6 12.6 21.2 12 26c-.6-4.8-1.2-7.4-2.9-9.1C7.4 15.2 4.8 14.6 0 14c4.8-.6 7.4-1.2 9.1-2.9C10.8 9.4 11.4 6.8 12 2Z"
      fill="currentColor"
      transform="scale(0.85) translate(2 0)"
    />
  </svg>
);

export const PlusDoodle = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M12 3v18M3 12h18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const SquiggleUnderline = ({ className = "", stroke = "#FF006E" }) => (
  <svg viewBox="0 0 220 22" fill="none" className={className} aria-hidden="true" preserveAspectRatio="none">
    <path
      d="M4 14c22-9 44-9 66-3s44 8 66 2 48-9 80-4"
      stroke={stroke}
      strokeWidth="6"
      strokeLinecap="round"
    />
  </svg>
);

export const CircleScribble = ({ className = "" }) => (
  <svg viewBox="0 0 260 90" fill="none" className={className} aria-hidden="true" preserveAspectRatio="none">
    <path
      d="M133 9C64 2 12 20 10 46c-2 27 62 42 130 38 62-4 112-22 108-46C244 15 190 4 118 10"
      stroke="#FF006E"
      strokeWidth="5"
      strokeLinecap="round"
    />
  </svg>
);

export const ArrowDoodle = ({ className = "", stroke = "#0D0D0D" }) => (
  <svg viewBox="0 0 120 90" fill="none" className={className} aria-hidden="true">
    <path
      d="M8 10c34 4 58 20 70 46 4 9 7 18 9 28M60 62l27 25 6-35"
      stroke={stroke}
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export const CrossDoodle = ({ className = "" }) => (
  <svg viewBox="0 0 24 32" fill="none" className={className} aria-hidden="true">
    <path d="M12 2v28M4 10h16" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" />
  </svg>
);

/* rotating circular sticker badge */
export const CircularBadge = ({ text, className = "", inner }) => (
  <div className={`relative ${className}`} data-testid="circular-badge">
    <svg viewBox="0 0 120 120" className="w-full h-full animate-spin-slow">
      <defs>
        <path id="badge-circle-path" d="M 60,60 m -46,0 a 46,46 0 1,1 92,0 a 46,46 0 1,1 -92,0" />
      </defs>
      <text fontSize="12.5" letterSpacing="2.2" fill="currentColor" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
        <textPath href="#badge-circle-path">{text}</textPath>
      </text>
    </svg>
    <div className="absolute inset-0 flex items-center justify-center">{inner}</div>
  </div>
);
